export default {
  INTERACTION: 'interaction',
  PAGE_VIEW: 'pageView',
  FORM_SUBMIT: 'formSubmit',
};
